import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatSnackBar } from '@angular/material';
import { OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
var BorradoresComponent = /** @class */ (function () {
    function BorradoresComponent(_userService, store, dialog, spinner, snackBar) {
        this._userService = _userService;
        this.store = store;
        this.dialog = dialog;
        this.spinner = spinner;
        this.snackBar = snackBar;
        this.borradores = [];
    }
    BorradoresComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._userService.getDrafts().subscribe(function (response) {
            console.log('getDrafts response', response);
            _this.borradores = response.borradores;
        }, function (error) {
            console.log(error);
        });
    };
    BorradoresComponent.prototype.ngDoCheck = function () {
    };
    BorradoresComponent.prototype.loadDraft = function (borrador) {
        var _this = this;
        //console.log('loadDraft')
        this.spinner.show();
        localStorage.clear();
        sessionStorage.setItem("borrador", borrador.id);
        this._userService.getDraft(borrador.id).subscribe(function (response) {
            console.log('loadDraft response', response);
            //console.log(response)
            //Cargar todos los localStorage existentes dentro de la app -- Agregar más si es necesario.
            if (response.info.tipo_sol)
                localStorage.setItem("tipo_sol", JSON.stringify(response.info.tipo_sol));
            else
                localStorage.setItem("tipo_sol", JSON.stringify([]));
            if (response.info.tipo_solicitud)
                localStorage.setItem("tipo_solicitud", JSON.stringify(response.info.tipo_solicitud));
            else
                localStorage.setItem("tipo_solicitud", JSON.stringify([]));
            if (response.info.tipo_propiedad)
                localStorage.setItem("tipo_propiedad", JSON.stringify(response.info.tipo_propiedad));
            else
                localStorage.setItem("tipo_propiedad", JSON.stringify([]));
            if (response.info.cip)
                localStorage.setItem("cip", JSON.stringify(response.info.cip));
            else
                localStorage.setItem("cip", JSON.stringify([]));
            if (response.info.propiedad)
                localStorage.setItem("propiedad", JSON.stringify(response.info.propiedad));
            else
                localStorage.setItem("propiedad", JSON.stringify([]));
            if (response.info.declaracion)
                localStorage.setItem("declaracion", JSON.stringify(response.info.declaracion));
            else
                localStorage.setItem("declaracion", JSON.stringify([]));
            if (response.info.permiso_notariado)
                localStorage.setItem("permiso_notariado", JSON.stringify(response.info.permiso_notariado));
            else
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
            if (response.info.representantes)
                localStorage.setItem("representantes", JSON.stringify(response.info.representantes));
            else
                localStorage.setItem("representantes", JSON.stringify([]));
            if (response.info.propietarios)
                localStorage.setItem("propietarios", JSON.stringify(response.info.propietarios));
            else
                localStorage.setItem("propietarios", JSON.stringify([]));
            if (response.info.empresas)
                localStorage.setItem("empresas", JSON.stringify(response.info.empresas));
            else
                localStorage.setItem("empresas", JSON.stringify([]));
            if (response.info.arquitectos)
                localStorage.setItem("arquitectos", JSON.stringify(response.info.arquitectos));
            else
                localStorage.setItem("arquitectos", JSON.stringify([]));
            if (response.info.constructora)
                localStorage.setItem("constructora", JSON.stringify(response.info.constructora));
            else
                localStorage.setItem("constructora", JSON.stringify([]));
            if (response.info.constructores)
                localStorage.setItem("constructores", JSON.stringify(response.info.constructores));
            else
                localStorage.setItem("constructores", JSON.stringify([]));
            if (response.info.informe)
                localStorage.setItem("informe", JSON.stringify(response.info.informe));
            else
                localStorage.setItem("informe", JSON.stringify([]));
            if (response.info.antecedentes)
                localStorage.setItem("antecedentes", JSON.stringify(response.info.antecedentes));
            else
                localStorage.setItem("antecedentes", JSON.stringify([]));
            if (response.info.antecedentes_edif)
                localStorage.setItem("antecedentes_edif", JSON.stringify(response.info.antecedentes_edif));
            else
                localStorage.setItem("antecedentes_edif", JSON.stringify([]));
            if (response.info.proyecto)
                localStorage.setItem("proyecto", JSON.stringify(response.info.proyecto));
            else
                localStorage.setItem("proyecto", JSON.stringify([]));
            if (response.info.plazo)
                localStorage.setItem("plazo", JSON.stringify(response.info.plazo));
            else
                localStorage.setItem("plazo", JSON.stringify([]));
            if (response.info.tipo_recepcion)
                localStorage.setItem("tipo_recepcion", JSON.stringify(response.info.tipo_recepcion));
            else
                localStorage.setItem("tipo_recepcion", JSON.stringify([]));
            if (response.info.Permisos)
                localStorage.setItem("Permisos", JSON.stringify(response.info.Permisos));
            else
                localStorage.setItem("Permisos", JSON.stringify([]));
            if (response.info.datos_proyecto)
                localStorage.setItem("datos_proyecto", JSON.stringify(response.info.datos_proyecto));
            else
                localStorage.setItem("datos_proyecto", JSON.stringify([]));
            if (response.info.caracteristica_proyecto)
                localStorage.setItem("caracteristica_proyecto", JSON.stringify(response.info.caracteristica_proyecto));
            else
                localStorage.setItem("caracteristica_proyecto", JSON.stringify([]));
            if (response.info.recepcion)
                localStorage.setItem("recepcion", JSON.stringify(response.info.recepcion));
            else
                localStorage.setItem("recepcion", JSON.stringify([]));
            if (response.info.registro_bienes)
                localStorage.setItem("registro_bienes", JSON.stringify(response.info.registro_bienes));
            else
                localStorage.setItem("registro_bienes", JSON.stringify([]));
            if (response.info.ampliacion)
                localStorage.setItem("ampliacion", JSON.stringify(response.info.ampliacion));
            else
                localStorage.setItem("ampliacion", JSON.stringify([]));
            if (response.info.recepcion_parcial)
                localStorage.setItem("recepcion_parcial", JSON.stringify(response.info.recepcion_parcial));
            else
                localStorage.setItem("recepcion_parcial", JSON.stringify([]));
            if (response.info.superficie)
                localStorage.setItem("superficie", JSON.stringify(response.info.superficie));
            else
                localStorage.setItem("superficie", JSON.stringify([]));
            if (response.info.unidades)
                localStorage.setItem("unidades", JSON.stringify(response.info.unidades));
            else
                localStorage.setItem("unidades", JSON.stringify([]));
            if (response.info.disposicion)
                localStorage.setItem("disposicion", JSON.stringify(response.info.disposicion));
            else
                localStorage.setItem("disposicion", JSON.stringify([]));
            if (response.info.permisos_recep)
                localStorage.setItem("permisos_recep", JSON.stringify(response.info.permisos_recep));
            else
                localStorage.setItem("permisos_recep", JSON.stringify([]));
            if (response.info.clasificacion)
                localStorage.setItem("clasificacion", JSON.stringify(response.info.clasificacion));
            else
                localStorage.setItem("clasificacion", JSON.stringify([]));
            if (response.info.independiente)
                localStorage.setItem("independiente", JSON.stringify(response.info.independiente));
            else
                localStorage.setItem("independiente", JSON.stringify([]));
            if (response.info.archivos)
                localStorage.setItem("archivos", JSON.stringify(response.info.archivos));
            else
                localStorage.setItem("archivos", JSON.stringify([]));
            if (response.info.tipo_solicitud)
                localStorage.setItem("tipo_solicitud", JSON.stringify(response.info.tipo_solicitud));
            else
                localStorage.setItem("tipo_solicitud", JSON.stringify([]));
            if (response.info.destino)
                localStorage.setItem("destino", JSON.stringify(response.info.destino));
            else
                localStorage.setItem("destino", JSON.stringify([]));
            if (response.info.tipo_aprobacion)
                localStorage.setItem("tipo_aprobacion", JSON.stringify(response.info.tipo_aprobacion));
            else
                localStorage.setItem("tipo_aprobacion", JSON.stringify([]));
            if (response.info.superficie_anteproyecto)
                localStorage.setItem("superficie_anteproyecto", JSON.stringify(response.info.superficie_anteproyecto));
            else
                localStorage.setItem("superficie_anteproyecto", JSON.stringify([]));
            if (response.info.normas_urbanisticas)
                localStorage.setItem("normas_urbanisticas", JSON.stringify(response.info.normas_urbanisticas));
            else
                localStorage.setItem("normas_urbanisticas", JSON.stringify([]));
            if (response.info.disposiciones_esp)
                localStorage.setItem("disposiciones_esp", JSON.stringify(response.info.disposiciones_esp));
            else
                localStorage.setItem("disposiciones_esp", JSON.stringify([]));
            if (response.info.autorizaciones)
                localStorage.setItem("autorizaciones", JSON.stringify(response.info.autorizaciones));
            else
                localStorage.setItem("autorizaciones", JSON.stringify([]));
            if (response.info.uso_publico)
                localStorage.setItem("uso_publico", JSON.stringify(response.info.uso_publico));
            else
                localStorage.setItem("uso_publico", JSON.stringify([]));
            if (response.info.anteproy_condominio)
                localStorage.setItem("anteproy_condominio", JSON.stringify(response.info.anteproy_condominio));
            else
                localStorage.setItem("anteproy_condominio", JSON.stringify([]));
            if (response.info.condiciones)
                localStorage.setItem("condiciones", JSON.stringify(response.info.condiciones));
            else
                localStorage.setItem("condiciones", JSON.stringify([]));
            if (response.info.permisos_recepciones)
                localStorage.setItem("permisos_recepciones", JSON.stringify(response.info.permisos_recepciones));
            else
                localStorage.setItem("permisos_recepciones", JSON.stringify([]));
            if (response.info.tipo_permiso)
                localStorage.setItem("tipo_permiso", JSON.stringify(response.info.tipo_permiso));
            else
                localStorage.setItem("tipo_permiso", JSON.stringify([]));
            if (response.info.informe_revisor)
                localStorage.setItem("informe_revisor", JSON.stringify(response.info.informe_revisor));
            else
                localStorage.setItem("informe_revisor", JSON.stringify([]));
            if (response.info.informe_revisor)
                localStorage.setItem("otras_solicitudes", JSON.stringify(response.info.otras_solicitudes));
            else
                localStorage.setItem("otras_solicitudes", JSON.stringify([]));
            if (response.info.calculistas)
                localStorage.setItem("calculistas", JSON.stringify(response.info.calculistas));
            else
                localStorage.setItem("calculistas", JSON.stringify([]));
            if (response.info.revisor)
                localStorage.setItem("revisor", JSON.stringify(response.info.revisor));
            else
                localStorage.setItem("revisor", JSON.stringify([]));
            if (response.info.caract_anteproyecto)
                localStorage.setItem("caract_anteproyecto", JSON.stringify(response.info.caract_anteproyecto));
            else
                localStorage.setItem("caract_anteproyecto", JSON.stringify([]));
            if (response.info.s_permiso_primitivo)
                localStorage.setItem("s_permiso_primitivo", JSON.stringify(response.info.s_permiso_primitivo));
            else
                localStorage.setItem("s_permiso_primitivo", JSON.stringify([]));
            if (response.info.cambio_destino)
                localStorage.setItem("cambio_destino", JSON.stringify(response.info.cambio_destino));
            else
                localStorage.setItem("cambio_destino", JSON.stringify([]));
            if (response.info.cambio_profesional)
                localStorage.setItem("cambio_profesional", JSON.stringify(response.info.cambio_profesional));
            else
                localStorage.setItem("cambio_profesional", JSON.stringify([]));
            if (response.info.superficie_proyecto_modificado)
                localStorage.setItem("superficie_proyecto_modificado", JSON.stringify(response.info.superficie_proyecto_modificado));
            else
                localStorage.setItem("superficie_proyecto_modificado", JSON.stringify([]));
            if (response.info.nuevas_normas)
                localStorage.setItem("nuevas_normas", JSON.stringify(response.info.nuevas_normas));
            else
                localStorage.setItem("nuevas_normas", JSON.stringify([]));
            if (response.info.tipo_proyecto)
                localStorage.setItem("tipo_proyecto", JSON.stringify(response.info.tipo_proyecto));
            else
                localStorage.setItem("tipo_proyecto", JSON.stringify([]));
            if (response.info.inspectorObra)
                localStorage.setItem("inspectorObra", JSON.stringify(response.info.inspectorObra));
            else
                localStorage.setItem("inspectorObra", JSON.stringify([]));
            if (response.info.perm_recep_ant)
                localStorage.setItem("perm_recep_ant", JSON.stringify(response.info.perm_recep_ant));
            else
                localStorage.setItem("perm_recep_ant", JSON.stringify([]));
            if (response.info.profesionalComp)
                localStorage.setItem("profesionalComp", JSON.stringify(response.info.profesionalComp));
            else
                localStorage.setItem("profesionalComp", JSON.stringify([]));
            if (response.info.tipo_loteo)
                localStorage.setItem("tipo_loteo", JSON.stringify(response.info.tipo_loteo));
            else
                localStorage.setItem("tipo_loteo", JSON.stringify([]));
            if (response.info.cond_anteproy)
                localStorage.setItem("cond_anteproy", JSON.stringify(response.info.cond_anteproy));
            else
                localStorage.setItem("cond_anteproy", JSON.stringify([]));
            if (response.info.caract_anteproy_loteo)
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify(response.info.caract_anteproy_loteo));
            else
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify([]));
            if (response.info.tipo_division)
                localStorage.setItem("tipo_division", JSON.stringify(response.info.tipo_division));
            else
                localStorage.setItem("tipo_division", JSON.stringify([]));
            if (response.info.permiso_urb)
                localStorage.setItem("permiso_urb", JSON.stringify(response.info.permiso_urb));
            else
                localStorage.setItem("permiso_urb", JSON.stringify([]));
            if (response.info.caract_fusion)
                localStorage.setItem("caract_fusion", JSON.stringify(response.info.caract_fusion));
            else
                localStorage.setItem("caract_fusion", JSON.stringify([]));
            if (response.info.caract_division)
                localStorage.setItem("caract_division", JSON.stringify(response.info.caract_division));
            else
                localStorage.setItem("caract_division", JSON.stringify([]));
            if (response.info.porcentajes_anteproy)
                localStorage.setItem("porcentajes_anteproy", JSON.stringify(response.info.porcentajes_anteproy));
            else
                localStorage.setItem("porcentajes_anteproy", JSON.stringify([]));
            if (response.info.loteo_const)
                localStorage.setItem("loteo_const", JSON.stringify(response.info.loteo_const));
            else
                localStorage.setItem("loteo_const", JSON.stringify([]));
            if (response.info.tipo_division)
                localStorage.setItem("tipo_division", JSON.stringify(response.info.tipo_division));
            else
                localStorage.setItem("tipo_division", JSON.stringify([]));
            if (response.info.tipo_loteo)
                localStorage.setItem("tipo_loteo", JSON.stringify(response.info.tipo_loteo));
            else
                localStorage.setItem("tipo_loteo", JSON.stringify([]));
            if (response.info.permiso_urb)
                localStorage.setItem("permiso_urb", JSON.stringify(response.info.permiso_urb));
            else
                localStorage.setItem("permiso_urb", JSON.stringify([]));
            if (response.info.loteo_const)
                localStorage.setItem("loteo_const", JSON.stringify(response.info.loteo_const));
            else
                localStorage.setItem("loteo_const", JSON.stringify([]));
            if (response.info.tipo_mod)
                localStorage.setItem("tipo_mod", JSON.stringify(response.info.tipo_mod));
            else
                localStorage.setItem("tipo_mod", JSON.stringify([]));
            if (response.info.reso_mod)
                localStorage.setItem("reso_mod", JSON.stringify(response.info.reso_mod));
            else
                localStorage.setItem("reso_mod", JSON.stringify([]));
            if (response.info.mod_parcial)
                localStorage.setItem("mod_parcial", JSON.stringify(response.info.mod_parcial));
            else
                localStorage.setItem("mod_parcial", JSON.stringify([]));
            if (response.info.caract_proy_mod)
                localStorage.setItem("caract_proy_mod", JSON.stringify(response.info.caract_proy_mod));
            else
                localStorage.setItem("caract_proy_mod", JSON.stringify([]));
            if (response.info.planos_mod)
                localStorage.setItem("planos_mod", JSON.stringify(response.info.planos_mod));
            else
                localStorage.setItem("planos_mod", JSON.stringify([]));
            if (response.info.caract_solicitud)
                localStorage.setItem("caract_solicitud", JSON.stringify(response.info.caract_solicitud));
            else
                localStorage.setItem("caract_solicitud", JSON.stringify([]));
            if (response.info.caract_proy_garantia)
                localStorage.setItem("caract_proy_garantia", JSON.stringify(response.info.caract_proy_garantia));
            else
                localStorage.setItem("caract_proy_garantia", JSON.stringify([]));
            if (response.info.lotes_enajenar)
                localStorage.setItem("lotes_enajenar", JSON.stringify(response.info.lotes_enajenar));
            else
                localStorage.setItem("lotes_enajenar", JSON.stringify([]));
            if (response.info.caract_sol)
                localStorage.setItem("caract_sol", JSON.stringify(response.info.caract_sol));
            else
                localStorage.setItem("caract_sol", JSON.stringify([]));
            if (response.info.cuenta_con_mod)
                localStorage.setItem("cuenta_con_mod", JSON.stringify(response.info.cuenta_con_mod));
            else
                localStorage.setItem("cuenta_con_mod", JSON.stringify([]));
            if (response.info.tipo_garantia)
                localStorage.setItem("tipo_garantia", JSON.stringify(response.info.tipo_garantia));
            else
                localStorage.setItem("tipo_garantia", JSON.stringify([]));
            if (response.info.cuenta_con_mod)
                localStorage.setItem("cuenta_con_mod", JSON.stringify(response.info.cuenta_con_mod));
            else
                localStorage.setItem("cuenta_con_mod", JSON.stringify([]));
            if (response.info.tipo_solicitud_def_urb_def_urb)
                localStorage.setItem("tipo_solicitud_def_urb_def_urb", JSON.stringify(response.info.tipo_solicitud_def_urb_def_urb));
            else
                localStorage.setItem("tipo_solicitud_def_urb_def_urb", JSON.stringify([]));
            if (response.info.reglamento_copropiedad)
                localStorage.setItem("reglamento_copropiedad", JSON.stringify(response.info.reglamento_copropiedad));
            else
                localStorage.setItem("reglamento_copropiedad", JSON.stringify([]));
            if (response.info.tipo_condominio)
                localStorage.setItem("tipo_condominio", JSON.stringify(response.info.tipo_condominio));
            else
                localStorage.setItem("tipo_condominio", JSON.stringify([]));
            if (response.info.permiso_demolicion)
                localStorage.setItem("permiso_demolicion", JSON.stringify(response.info.permiso_demolicion));
            else
                localStorage.setItem("permiso_demolicion", JSON.stringify([]));
            if (response.info.tipo_autorizacion)
                localStorage.setItem("tipo_autorizacion", JSON.stringify(response.info.tipo_autorizacion));
            else
                localStorage.setItem("tipo_autorizacion", JSON.stringify([]));
            _this.getForm(response.form, borrador.title);
            _this.spinner.hide();
            _this.dialog.closeAll();
            //console.log(response)
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    BorradoresComponent.prototype.getForm = function (id, title) {
        this.store.dispatch(new FormActions.FormUpdate(id, title));
        localStorage.setItem("form", id);
        this.dialog.closeAll();
    };
    BorradoresComponent.prototype.deleteDraft = function (selected) {
        var _this = this;
        console.log('deleteDraft selected', selected);
        //Swal.fire({
        swal({
            type: 'warning',
            title: "Estás seguro de eliminar el borrador?",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            allowOutsideClick: false
        }).then(function (result) {
            console.log("accept");
            //if (result.value) {
            _this._userService.deleteDraft(selected).subscribe(function (response) {
                if (response.message) {
                    //alerta de error            
                    console.log("response.message", response.message);
                }
                sessionStorage.removeItem("borrador");
                _this.dialog.closeAll();
                console.log('borrador eliminado');
                //Swal.fire({
                swal({
                    title: 'Deleted!',
                    text: 'Tu borrador fue eliminado.',
                    type: 'success'
                });
                /*this.snackBar.open("Borrador eliminado", "Cerrar", {
                  duration: 3000
                });*/
            }, function (error) {
                console.log(error);
            }); //subscribe
            // }
        }, function (dismiss) {
            console.log("abajo dismiss", dismiss);
            if (dismiss === 'cancel') {
                swal({
                    title: 'Cancelled',
                    text: 'Tu borrador no se eliminó.',
                    type: 'error'
                });
            }
        });
    };
    return BorradoresComponent;
}());
export { BorradoresComponent };
